module.exports = __webpack_public_path__ + "static/media/sushirice.ff0adf28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/base/sushirice.jpg
// module id = 100
// module chunks = 0